(function () {
  "use strict";

  AccountForCourseCtrl.$inject = ['$scope', '$location', '$rootScope', 'resolveData'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AccountForCourseCtrl', AccountForCourseCtrl);

  function AccountForCourseCtrl($scope, $location, $rootScope, resolveData) {
    $rootScope.page = {name: 'addExistingTrainees', title: "Add Existing Trainees"};

    // small shim to populate resolvedData
    $scope.resolvedData = resolveData;

    var queryParams = $location.search();

    $scope.montara = queryParams.course;
  }

})();
